'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
require('react');
var withIconProps = require('../../../../withIconProps-365ff8d5.js');
var react = require('@emotion/react');
require('@babel/runtime/helpers/objectWithoutProperties');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('@styled-system/should-forward-prop');
require('styled-system');
require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);

var SvgComponent = function SvgComponent(props) {
  return react.jsx("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 41"
  }, props), react.jsx("defs", null, react.jsx("path", {
    id: "Error_svg__a",
    d: "M0 .025h39.916V36.34H0z"
  }), react.jsx("path", {
    id: "Error_svg__c",
    d: "M0 40.13h39.87V0H0z"
  })), react.jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react.jsx("mask", {
    id: "Error_svg__b",
    fill: "#fff"
  }, react.jsx("use", {
    xlinkHref: "#Error_svg__a"
  })), react.jsx("path", {
    fill: "#FF5636",
    d: "M39.812 30.656 21.989.071a.093.093 0 0 0-.08-.046h-3.902a.093.093 0 0 0-.08.046L.104 30.656a.764.764 0 0 0-.104.385v5.206c0 .051.042.093.093.093h39.823V31.04a.765.765 0 0 0-.104-.385",
    mask: "url(#Error_svg__b)"
  }), react.jsx("path", {
    fill: "#FFD6C9",
    d: "M2.614 33.633v-2.105c0-.016.005-.032.013-.046L19.457 2.66a.093.093 0 0 1 .08-.046h.927c.033 0 .063.018.08.046l16.83 28.822c.007.014.012.03.012.046v2.105a.093.093 0 0 1-.093.092H2.707a.093.093 0 0 1-.093-.092",
    mask: "url(#Error_svg__b)"
  }), react.jsx("mask", {
    id: "Error_svg__d",
    fill: "#fff"
  }, react.jsx("use", {
    xlinkHref: "#Error_svg__c"
  })), react.jsx("path", {
    fill: "#002F34",
    d: "M24.118 16.601a3.987 3.987 0 1 0 0 7.974 3.987 3.987 0 0 0 0-7.974m0 2.791c.66 0 1.196.537 1.196 1.196 0 .66-.537 1.196-1.196 1.196-.66 0-1.196-.536-1.196-1.196 0-.66.536-1.196 1.196-1.196M17.255 19.318l-2.905 2.904h-1.147v-1.147l2.904-2.905h1.148z",
    mask: "url(#Error_svg__d)"
  }), react.jsx("path", {
    fill: "#002F34",
    d: "m13.203 19.318 2.904 2.904h1.148v-1.147L14.35 18.17h-1.147z",
    mask: "url(#Error_svg__d)"
  }), react.jsx("path", {
    fill: "#AA133D",
    d: "M5.62 40.13h1.57v-3.79H5.62zM32.68 40.13h1.568v-3.79H32.68z",
    mask: "url(#Error_svg__d)"
  }), react.jsx("path", {
    fill: "#002F34",
    d: "M18.758 26.928c-1.263 0-2.287.995-2.287 2.222 0 1.228 1.024 2.223 2.287 2.223 1.264 0 2.288-.995 2.288-2.223 0-1.227-1.024-2.222-2.288-2.222m0 1.383c.477 0 .864.376.864.84 0 .462-.387.839-.864.839a.853.853 0 0 1-.864-.84c0-.463.388-.84.864-.84",
    mask: "url(#Error_svg__d)"
  })));
};
var Component = withIconProps.withIconProps(SvgComponent);

exports["default"] = Component;
//# sourceMappingURL=Error.js.map
